import React from 'react';
import PropTypes from 'prop-types';
import styles from './Layout.module.css';

function Container({ children }) {
  return <div className={styles.container}>{children}</div>;
}

function Main({ children }) {
  return <div className={styles.main}>{children}</div>;
}

function PageTitle({ children }) {
  return <div className={styles.pageTitle}>{children}</div>;
}

function Row({ children }) {
  return <div className={styles.row}>{children}</div>;
}

function HalfRow({ children }) {
  return <div className={styles.halfRow}>{children}</div>;
}

function Section({ children }) {
  return (
    <Row>
      <HalfRow>{children}</HalfRow>
    </Row>
  );
}

function ValidationTitle({ children }) {
  return <h2 className={styles.validationTitle}>{children}</h2>;
}

function ValidationText({ children }) {
  return <p className={styles.validationText}>{children}</p>;
}

function Validation({ title, text }) {
  return (
    <div className={styles.validation}>
      <ValidationTitle>{title}</ValidationTitle>
      <ValidationText>{text}</ValidationText>
    </div>
  );
}

Container.propTypes = {
  children: PropTypes.node.isRequired,
};
HalfRow.propTypes = {
  children: PropTypes.node.isRequired,
};
Main.propTypes = {
  children: PropTypes.node.isRequired,
};
PageTitle.propTypes = {
  children: PropTypes.node.isRequired,
};
Row.propTypes = {
  children: PropTypes.node.isRequired,
};
ValidationTitle.propTypes = {
  children: PropTypes.node.isRequired,
};
ValidationText.propTypes = {
  children: PropTypes.node.isRequired,
};
Section.propTypes = {
  children: PropTypes.node.isRequired,
};

Validation.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export {
  Container,
  HalfRow,
  Main,
  Section,
  PageTitle,
  Row,
  Validation,
  ValidationTitle,
  ValidationText,
};
